import React, { useContext, useState } from "react";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { useCurrentUserData } from "hooks/useUserData";
import { useDataGrid } from "hooks/useDataGrid";
import * as CSC from "SC";
import { GlobalContext } from "store/globalContext";
import { DataGrid } from "UI/DataGrid";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";
import { AddNewRegionDialog } from "./AddNewRegionDialog";
import { EditRegionDialog } from "./EditRegionDialog";

export const Regions = () => {
  const { userData } = useContext(GlobalContext);
  const disableDownload =
    userData?.role !== "Super Admin" && userData?.role !== "Admin";

  const { isReadOnlyAccess, isSuperAdmin } = useCurrentUserData();
  const [isAddNewDialogOpen, setIsAddNewDialogOpen] = useState(false);

  const [currentRow, setCurrentRow] = useState("");

  const columns =
    userData?.role === "Super Admin" ||
    userData?.email === "admin@referral-stream.com"
      ? [
          {
            label: "ID",
            field: "id",
            xs: 4,
            sm: 4,
            md: 4,
            renderer: ({ id }) => `${String(id).slice(0, 8)}...`,
          },
          {
            label: "Region Name",
            field: "label",
            xs: 4,
            sm: 4,
            md: 4,
            renderer: ({ label }) => (
              <TextFieldWithEllipsis>{label}</TextFieldWithEllipsis>
            ),
          },
          {
            label: "Recipient",
            field: "organizationName",
            xs: 4,
            sm: 4,
            md: 4,
            renderer: ({ organizationName }) => (
              <TextFieldWithEllipsis>{organizationName}</TextFieldWithEllipsis>
            ),
          },
        ]
      : [
          {
            label: "ID",
            field: "id",
            xs: 5,
            sm: 5,
            md: 5,
            renderer: ({ id }) => `${String(id).slice(0, 8)}...`,
          },
          {
            label: "Region Name",
            field: "label",
            xs: 7,
            sm: 7,
            md: 7,
            renderer: ({ label }) => (
              <TextFieldWithEllipsis>{label}</TextFieldWithEllipsis>
            ),
          },
        ];

  const dataGrid = useDataGrid({
    url: "/regions",
    defaultSorter: {
      name: "label",
      order: "asc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Regions`,
  });

  const handleRowClick = (row) => setCurrentRow(row);

  return (
    <CommonOutletTemplate title="Regions" isLoading={!dataGrid?.rows}>
      <DataGrid
        columns={columns}
        handleRowClick={handleRowClick}
        {...dataGrid}
        disableDownload={disableDownload}
        afterSearchContent={
          !isReadOnlyAccess &&
          !isSuperAdmin && (
            <CSC.BlueButton
              variant="outlined"
              onClick={() => setIsAddNewDialogOpen(true)}
            >
              Add New Region
            </CSC.BlueButton>
          )
        }
      />
      {!isReadOnlyAccess && !isSuperAdmin && (
        <AddNewRegionDialog
          open={isAddNewDialogOpen}
          handleClose={() => setIsAddNewDialogOpen(false)}
          refreshList={() => dataGrid.loadData()}
        />
      )}
      <EditRegionDialog
        region={currentRow}
        handleClose={() => setCurrentRow(null)}
        refreshList={() => dataGrid.loadData()}
      />
    </CommonOutletTemplate>
  );
};
